export default __webpack_public_path__ + "static/women3-8f3484f66b3746f8313d92ed5d4fb13c.webp";